<template lang="pug">
    title-modal-layout.select-media-vault-files-modal(v-bind="$attrs" :title="title" :disableCancelButton="disableCancelButton" :disableCancelButtonClose="true"
            :confirmButtonText="confirmButtonText" cancelButtonText="Go Back" @approve="select" @cancel="cancel" ref="modal")
        template(v-slot:section)
            scrollable-layout(:maxHeight="true")
                media-vault-view.select-media-vault-files-modal__content(:albumId.sync="selectedAlbumId" :fileIds.sync="selectedFileIds" mode="select")
</template>

<script>
export default {
    name: 'select-media-vault-files-modal',

    props: {
        title: {
            type: String,
            default: 'Select Media Vault Files',
        },
        confirmButtonText: {
            type: String,
            default: 'Select',
        },
        selected: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            selectedAlbumId: null,
            selectedFileIds: [],
        }
    },

    computed: {
        disableCancelButton() {
            return !this.selectedAlbumId
        },
    },

    methods: {
        select() {
            this.selected(this.selectedFileIds)
            this.$refs.modal.close()
        },

        cancel() {
            this.selectedAlbumId = null
        },
    },
}
</script>
